module.exports = __webpack_public_path__ + "img/Betreuungsstelle.cd359489.svg";